module.exports = [{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":960},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/Users/stefansietzen/Dev/portfolio.stefansietzen.at/src/cms/cms.js"},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":[""],"pluginConfig":{"head":true}},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/stefansietzen/Dev/portfolio.stefansietzen.at/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
